import { motion } from 'framer-motion';

const ComplianceSection = () => {
  const benefits = [
    { icon: 'ri-file-search-line', text: 'Análisis de documentación' },
    { icon: 'ri-alert-line', text: 'Detección de riesgos' },
    { icon: 'ri-shield-check-line', text: 'Prevención de multas' },
    { icon: 'ri-lightbulb-line', text: 'Recomendaciones personalizadas' },
  ];

  return (
    <section className="py-24 bg-black relative overflow-hidden">
      {/* Radial Gradient Background */}
      <div className="absolute inset-0 bg-gradient-radial from-primary-yellow/10 via-transparent to-transparent"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="inline-block mb-8"
        >
          <div className="bg-primary-yellow text-black text-sm font-bold px-6 py-3 rounded-full animate-pulse">
            Próximamente
          </div>
        </motion.div>

        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-5xl lg:text-6xl font-bold text-white mb-6"
        >
          Compliance Empresarial
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-2xl text-primary-yellow font-light mb-8"
        >
          Diagnóstico de cumplimiento legal
        </motion.p>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="text-lg text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed"
        >
          Próximamente ofreceremos diagnóstico de cumplimiento legal para empresas mediante metodología estructurada y revisión profesional. Este servicio permitirá analizar documentación empresarial, detectar riesgos regulatorios y entregar recomendaciones para mejorar el cumplimiento normativo.
        </motion.p>

        {/* Benefits Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto mb-12"
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 + index * 0.1, duration: 0.5 }}
              className="flex items-center space-x-3 bg-white/5 backdrop-blur-sm rounded-lg p-4 border border-primary-yellow/20"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-yellow rounded-full flex-shrink-0">
                <i className={`${benefit.icon} text-xl text-black`}></i>
              </div>
              <span className="text-white font-medium text-left">{benefit.text}</span>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          <button className="bg-primary-yellow text-black px-10 py-4 rounded-full font-bold hover:bg-yellow-400 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/50 inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer">
            <i className="ri-notification-line text-xl"></i>
            <span>Notificarme cuando esté disponible</span>
          </button>
        </motion.div>

        {/* Illustration */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 1, duration: 0.8 }}
          className="mt-16"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/53e73220dafd473e084e991028ee8a51.jpg"
            alt="Dashboard de Compliance"
            className="w-full max-w-3xl mx-auto rounded-2xl shadow-2xl shadow-yellow-500/20"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ComplianceSection;